/* ==========================================================================
   HerLoom Hair Plan — parcours et rendu
   --------------------------------------------------------------------------
   Le contenu et le calcul vivent dans herloom-hair-plan-catalog.js. Ce fichier
   collecte les réponses et affiche le plan.

   Découpe gratuit / verrouillé : la cliente repart avec le pourquoi — ce qui
   se passe sur ses cheveux, son réglage chiffré et deux faits qu'elle ignorait.
   Le comment, la méthode, est derrière le verrou.

   Suivi : compteurs d'étape uniquement. Aucune réponse ne sort du navigateur.
   ========================================================================== */

(function () {
  'use strict';

  const HHP = window.HHP;

  const ICONS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5 9 17.5 20 6.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10" rx="2.2"/><path d="M8.2 10.5V7.8a3.8 3.8 0 0 1 7.6 0v2.7"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6"/><path d="M20 4 11 13"/><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>'
  };

  /* Icones des reponses. Une seule grille 24x24, trait uniquement : elles se
     colorent avec l'accent du theme et restent lisibles a 22px.
     La clef vient du champ `i` de chaque option du catalogue. */
  const g = d => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';

  const JAW = '<path d="M9.6 8.8v2.4a2.4 2.4 0 0 0 4.8 0V8.8"/>';
  const hair = (bottom, flare) =>
    '<path d="M6.6 ' + bottom + 'V8.8a5.4 5.4 0 0 1 10.8 0V' + bottom + '"/>' + (flare || '');
  const SLASH = '<path d="M5 5 19 19"/>';
  const DROP = 'M12 4.4c3.2 3.6 5 5.8 5 8a5 5 0 0 1-10 0c0-2.2 1.8-4.4 5-8z';
  const CAL = '<rect x="3.8" y="5.4" width="16.4" height="14.4" rx="2.4"/>' +
    '<path d="M8.4 3.4v3.6M15.6 3.4v3.6M3.8 10.2h16.4"/>';
  const dot = (x, y) => '<path d="M' + x + ' ' + y + 'h.01" stroke-width="2.2"/>';

  const OPT_ICONS = {
    /* longueur : la meme tete, des meches de plus en plus longues */
    len1: g(JAW + hair(10.6)),
    len2: g(JAW + hair(13.4)),
    len3: g(JAW + hair(16)),
    len4: g(JAW + hair(18.6)),
    len5: g(JAW + hair(20, '<path d="M6.6 20q0 1.7-1.5 2.3M17.4 20q0 1.7 1.5 2.3"/>')),

    /* forme naturelle */
    straight: g('<path d="M8.5 4v16M12 4v16M15.5 4v16"/>'),
    wavy: g('<path d="M8.5 4c2.4 1.8 2.4 3 0 4.8s-2.4 3 0 4.8 2.4 3 0 4.8"/>' +
            '<path d="M15.5 4c-2.4 1.8-2.4 3 0 4.8s2.4 3 0 4.8-2.4 3 0 4.8"/>'),
    curly: g('<path d="M9.6 4.6c4 0 4 3.4 0 3.4s-4 3.4 0 3.4 4 3.4 0 3.4 4 3.4 0 3.4"/>'),
    coily: g('<path d="M9 4.4l3.2 2.6L9 9.6l3.2 2.6L9 14.8l3.2 2.6L9 20"/>'),

    /* epaisseur du cheveu : la meme meche, trois graisses */
    thin: g('<path d="M4.6 12c3.6-3.4 11.2 3.4 14.8 0" stroke-width="1"/>'),
    mid: g('<path d="M4.6 12c3.6-3.4 11.2 3.4 14.8 0" stroke-width="2.3"/>'),
    thick: g('<path d="M4.6 12c3.6-3.4 11.2 3.4 14.8 0" stroke-width="3.8"/>'),
    question: g('<circle cx="12" cy="12" r="8.2"/>' +
      '<path d="M9.7 9.6a2.4 2.4 0 0 1 4.7.7c0 1.7-2.4 2-2.4 3.5"/>' + dot(12, 16.6)),

    /* traitements */
    leaf: g('<path d="M19.2 4.8c0 7.4-4.7 11.9-10.6 11.9H5.2C5.2 9.3 9.9 4.8 15.8 4.8z"/>' +
            '<path d="M5.4 19.6c1.9-4.2 4.8-6.9 8.2-8.6"/>'),
    palette: g('<path d="M9.1 11.9 17.1 3.8a2.85 2.85 0 1 1 4 4L13 15.9"/>' +
      '<path d="M7.1 14.9a3 3 0 0 0-3 3c0 1.3-2.5 1.5-2 2 1.1 1.1 2.5 2 4 2a4 4 0 0 0 4-4 3 3 0 0 0-3-3z"/>'),
    streaks: g('<path d="M6.4 20.4V7.6M12 20.4V4.2M17.6 20.4V9.4"/>' +
      '<path d="M19.2 3l.6 1.5 1.5.6-1.5.6-.6 1.5-.6-1.5-1.5-.6 1.5-.6z"/>'),
    sparkle: g('<path d="M10.4 3.4l1.5 3.7 3.7 1.5-3.7 1.5-1.5 3.7-1.5-3.7L5.2 8.6l3.7-1.5z"/>' +
      '<path d="M17.4 13.6l.9 2.2 2.2.9-2.2.9-.9 2.2-.9-2.2-2.2-.9 2.2-.9z"/>'),
    rod: g('<path d="M4.8 4.6h14.4"/>' +
      '<path d="M8.4 7.4c4.2 0 4.2 3.2 0 3.2s-4.2 3.2 0 3.2 4.2 3.2 0 3.2"/>'),
    flatten: g('<path d="M4.4 5.2c2.5-2.4 5.1 2.4 7.6 0s5.1 2.4 7.6 0"/>' +
      '<path d="M4.4 19.4h15.2"/>' +
      '<path d="M12 8.8v5.2M9.2 11.6 12 14.4l2.8-2.8"/>'),

    /* etat des longueurs */
    checkCircle: g('<circle cx="12" cy="12" r="8.2"/><path d="M8.4 12.4 10.9 15l4.7-5.6"/>'),
    noDrop: g('<path d="' + DROP + '"/>' + SLASH),
    knot: g('<path d="M4 5.8h16a1.6 1.6 0 0 1 1.6 1.6v1.8H2.4V7.4A1.6 1.6 0 0 1 4 5.8z"/>' +
      '<path d="M6.2 9.2v9.2M10.1 9.2v9.2M13.9 9.2v9.2M17.8 9.2v9.2"/>'),
    split: g('<path d="M12 3.8v8.4M12 12.2l-2.8 8M12 12.2l2.8 8"/>'),

    /* cuir chevelu */
    smile: g('<circle cx="12" cy="12" r="8.2"/><path d="M8.6 13.8a4.3 4.3 0 0 0 6.8 0"/>' +
      dot(9.5, 9.9) + dot(14.5, 9.9)),
    drops2: g('<path d="M8 5.4c2.2 2.5 3.4 4 3.4 5.5a3.4 3.4 0 0 1-6.8 0c0-1.5 1.2-3 3.4-5.5z"/>' +
      '<path d="M16 11.2c2.2 2.5 3.4 4 3.4 5.5a3.4 3.4 0 0 1-6.8 0c0-1.5 1.2-3 3.4-5.5z"/>'),
    flakes: g('<path d="M4.8 18.6C6.6 11.6 10.3 7.3 15.4 5.4"/>' +
      '<circle cx="16.8" cy="12.6" r="1.1"/><circle cx="13.2" cy="16.4" r="1.1"/>' +
      '<circle cx="18.4" cy="17.8" r="1.1"/>'),

    /* objectif */
    sleek: g('<path d="M4.4 15.8c4.7-6.2 10.5-6.2 15.2 0"/>' +
      '<path d="M16.6 4.6l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>'),
    lift: g('<path d="M12 20.4V6.6M7.2 11.4 12 6.6l4.8 4.8"/><path d="M5 20.4v-4.8M19 20.4v-4.8"/>'),
    scissors: g('<path d="M6.6 5 16.9 16.4M17.4 5 7.1 16.4"/>' +
      '<circle cx="5.8" cy="18.3" r="2.2"/><circle cx="18.2" cy="18.3" r="2.2"/>'),
    bolt: g('<path d="M13.4 3 5.8 13.4h5.2L10.6 21l7.6-10.4H13z"/>'),

    /* blocage */
    rotate: g('<path d="M4.8 12a7.2 7.2 0 1 1 2.4 5.4"/><path d="M4.8 17.6v-4.4h4.4"/>'),
    frizz: g('<path d="M4.4 14.6c1.3-1.7 3.1-1.7 4.4 0s3.1 1.7 4.4 0 3.1-1.7 4.4 0"/>' +
      '<path d="M6.2 9.2 7.6 7.4M11.2 8 11.8 5.6M16.4 9.4 18 7.6"/>'),
    falls: g('<path d="M12 3.8v10.6M7.7 10.2 12 14.4l4.3-4.2"/><path d="M4.8 19.4h14.4"/>'),
    flame: g('<path d="M12 3.4c3.2 3.4 5.4 5.6 5.4 9a5.4 5.4 0 0 1-10.8 0c0-2 1-3.4 2.2-4.6' +
      '.2 1.6 1.1 2.4 2 2.4 1.4 0 2-1.6 1.2-6.8z"/>'),
    hourglass: g('<path d="M6.8 4h10.4M6.8 20h10.4"/>' +
      '<path d="M7.6 4c0 4 4.4 5.4 4.4 8s-4.4 4-4.4 8"/>' +
      '<path d="M16.4 4c0 4-4.4 5.4-4.4 8s4.4 4 4.4 8"/>'),

    /* frequence de chauffe */
    cal0: g(CAL + SLASH),
    cal1: g(CAL + dot(12, 14.4)),
    cal3: g(CAL + dot(8, 14.4) + dot(12, 14.4) + dot(16, 14.4)),
    cal6: g(CAL + dot(8, 13.4) + dot(12, 13.4) + dot(16, 13.4) +
      dot(8, 16.8) + dot(12, 16.8) + dot(16, 16.8)),

    /* produits */
    bottle: g('<path d="M9.4 3.6h5.2v2.8a4 4 0 0 1 2 3.4v8.4a2.2 2.2 0 0 1-2.2 2.2H9.6' +
      'a2.2 2.2 0 0 1-2.2-2.2V9.8a4 4 0 0 1 2-3.4z"/><path d="M7.4 12.6h9.2"/>'),
    jar: g('<path d="M5.6 8.8h12.8v9a2.4 2.4 0 0 1-2.4 2.4H8a2.4 2.4 0 0 1-2.4-2.4z"/>' +
      '<rect x="7" y="4.6" width="10" height="3.2" rx="1.2"/>'),
    spray: g('<path d="M9 8.6h5.6v10.6a1.8 1.8 0 0 1-1.8 1.8h-2a1.8 1.8 0 0 1-1.8-1.8z"/>' +
      '<path d="M10 8.6V5.4h3.8"/>' + dot(17.2, 5) + dot(19.6, 3.8) + dot(19.2, 7.2) + dot(17.4, 8.8)),
    shield: g('<path d="M12 3.4 19 6v5.4c0 4.4-2.8 7.6-7 9.2-4.2-1.6-7-4.8-7-9.2V6z"/>' +
      '<path d="M9.2 11.9 11.4 14l3.6-4.3"/>'),
    dropper: g('<path d="' + DROP + '"/><path d="M9.8 13.4a2.2 2.2 0 0 0 2 2"/>'),
    noCircle: g('<circle cx="12" cy="12" r="8.2"/><path d="M6.2 6.2 17.8 17.8"/>'),

    /* lavage */
    drops3: g('<path d="M7 4.6c1.9 2.2 3 3.4 3 4.7a3 3 0 0 1-6 0c0-1.3 1.1-2.5 3-4.7z"/>' +
      '<path d="M17 4.6c1.9 2.2 3 3.4 3 4.7a3 3 0 0 1-6 0c0-1.3 1.1-2.5 3-4.7z"/>' +
      '<path d="M12 13c1.9 2.2 3 3.4 3 4.7a3 3 0 0 1-6 0c0-1.3 1.1-2.5 3-4.7z"/>'),
    drop1: g('<path d="' + DROP + '"/>'),

    /* environnement */
    sun: g('<circle cx="12" cy="12" r="4.2"/><path d="M12 3v2.2M12 18.8V21M3 12h2.2M18.8 12H21' +
      'M5.6 5.6l1.6 1.6M16.8 16.8l1.6 1.6M18.4 5.6l-1.6 1.6M7.2 16.8l-1.6 1.6"/>'),
    pool: g('<path d="M9 3.6v10.8M14 3.6v10.8M9 7h5M9 10.6h5"/>' +
      '<path d="M3.4 17.8c2.1 0 2.1 1.8 4.3 1.8s2.1-1.8 4.3-1.8 2.1 1.8 4.3 1.8 2.1-1.8 4.3-1.8"/>'),
    waves: g('<path d="M3.4 10.4c2.1 0 2.1 1.8 4.3 1.8s2.1-1.8 4.3-1.8 2.1 1.8 4.3 1.8 2.1-1.8 4.3-1.8"/>' +
      '<path d="M3.4 15.6c2.1 0 2.1 1.8 4.3 1.8s2.1-1.8 4.3-1.8 2.1 1.8 4.3 1.8 2.1-1.8 4.3-1.8"/>'),
    dumbbell: g('<path d="M4 9.4v5.2M7 7.6v8.8M17 7.6v8.8M20 9.4v5.2M7 12h10"/>')
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function boot() { document.querySelectorAll('[data-hhp]').forEach(init); }

  function init(root) {
    if (!root || root.dataset.hhpReady === 'true') return;
    if (!HHP || !HHP.QUESTIONS || !HHP.buildPlan) return;
    root.dataset.hhpReady = 'true';

    const cfgEl = root.querySelector('[data-hhp-config]');
    let CFG = {};
    try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { CFG = {}; }
    const TEASER = (CFG.mode || 'full') === 'teaser';

    const screens = {};
    root.querySelectorAll('[data-screen]').forEach(el => { screens[el.dataset.screen] = el; });
    const mountQ = root.querySelector('[data-question-mount]');
    const mountR = root.querySelector('[data-result-mount]');
    const fill = root.querySelector('[data-fill]');
    const count = root.querySelector('[data-count]');
    const backBtn = root.querySelector('[data-back]');
    const library = root.querySelector('[data-hhp-library]');

    const SCREENS = HHP.SCREENS;
    let index = 0;
    let answers = {};
    let shadeFamilyOpen = null;
    let timers = [];
    const later = (fn, ms) => { const t = setTimeout(fn, ms); timers.push(t); return t; };
    const clearTimers = () => { timers.forEach(clearTimeout); timers = []; };

    /* ---- Suivi : étapes seulement, jamais les réponses ---- */

    const PH_KEY = CFG.phKey || '';
    const PH_HOST = (CFG.phHost || 'https://us.i.posthog.com').replace(/\/+$/, '');
    let phQueue = [];
    const randomId = () => {
      try {
        const a = new Uint8Array(9);
        window.crypto.getRandomValues(a);
        return Array.prototype.map.call(a, b => ('0' + b.toString(16)).slice(-2)).join('');
      } catch (e) { return String(Date.now()) + Math.random().toString(16).slice(2, 10); }
    };
    const storedId = (store, key) => {
      try {
        let v = window[store].getItem(key);
        if (!v) { v = randomId(); window[store].setItem(key, v); }
        return v;
      } catch (e) { return randomId(); }
    };
    const visitorId = storedId('localStorage', 'hhp_visitor');
    const sessionId = storedId('sessionStorage', 'hhp_session');

    function track(event, props) {
      if (!PH_KEY) return;
      const p = { distinct_id: visitorId, session: sessionId, mode: CFG.mode || 'full' };
      if (props) Object.keys(props).forEach(k => { p[k] = props[k]; });
      phQueue.push({ event: 'hhp_' + event, distinct_id: visitorId, properties: p,
                     timestamp: new Date().toISOString() });
    }
    function flushTrack(unloading) {
      if (!PH_KEY || !phQueue.length) return;
      const body = JSON.stringify({ api_key: PH_KEY, batch: phQueue });
      phQueue = [];
      const url = PH_HOST + '/batch/';
      try {
        if (unloading && navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
          return;
        }
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' },
                     body, keepalive: true }).catch(() => {});
      } catch (e) {}
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flushTrack(true);
    });
    window.addEventListener('pagehide', () => flushTrack(true));

    /* ---- Écrans ---- */

    function show(name) {
      Object.keys(screens).forEach(k => screens[k].classList.toggle('is-active', k === name));
      root.classList.toggle('is-door', name === 'door');
      if (name !== 'door') {
        const top = root.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function openDoors(then) {
      if (root.classList.contains('is-opening')) return;
      clearTimers();
      if (reduced) { root.classList.remove('is-door'); then(); return; }
      root.classList.add('is-opening');
      later(() => root.classList.add('is-white'), 1000);
      later(() => {
        root.classList.remove('is-opening');
        then();
        later(() => root.classList.remove('is-white'), 60);
      }, 1620);
    }

    /* ---- Questions ---- */

    const question = id => HHP.QUESTIONS.filter(q => q.id === id)[0];

    function optionMarkup(q, o, picked) {
      const glyph = OPT_ICONS[o.i] || OPT_ICONS.noCircle;
      return '<button type="button" role="' + (q.multi ? 'checkbox' : 'radio') + '"' +
        ' class="hsid__opt hhp__opt' + (q.multi ? ' hhp__opt--multi' : '') + '"' +
        ' data-q="' + esc(q.id) + '" data-value="' + esc(o.id) + '"' +
        ' aria-checked="' + (picked ? 'true' : 'false') + '">' +
        '<span class="hsid__opt-icon" aria-hidden="true">' + glyph + '</span>' +
        '<span class="hsid__opt-text"><span class="hsid__opt-label">' + esc(o.label) + '</span>' +
        (o.note ? '<span class="hsid__opt-desc">' + esc(o.note) + '</span>' : '') +
        '</span>' +
        '<span class="hhp__box" aria-hidden="true">' + ICONS.check + '</span>' +
        '</button>';
    }

    function shadeMarkup() {
      const current = answers.shadeTone ? HHP.SHADE_INDEX[answers.shadeTone] : null;
      const open = shadeFamilyOpen || (current && current.family) || null;
      const fams = HHP.SHADES.map(fam =>
        '<button type="button" class="hsid__fam" data-family="' + fam.id + '"' +
        ' aria-pressed="' + (fam.id === open) + '">' +
        '<span class="hsid__fam-dot" style="background:' + fam.swatch + '"></span>' +
        '<span>' + esc(fam.label) + '</span></button>').join('');
      let tones = '';
      if (open) {
        const f = HHP.SHADES.filter(x => x.id === open)[0];
        tones = '<div class="hsid__tones" role="group" aria-label="' + esc(f.label) + '">' +
          f.tones.map(t =>
            '<button type="button" class="hsid__tone" data-tone="' + t.v + '"' +
            ' aria-pressed="' + (answers.shadeTone === t.v) + '">' +
            '<span class="hsid__tone-dot" style="background:' + t.hex + '"></span>' +
            '<span class="hsid__tone-label">' + esc(t.l) + '</span></button>').join('') + '</div>';
      }
      return '<div class="hsid__fams" role="group">' + fams + '</div>' + tones;
    }

    const needsButton = ids => ids.length > 1 || question(ids[0]).multi;

    function renderScreen() {
      const ids = SCREENS[index];
      if (fill) fill.style.width = ((index / SCREENS.length) * 100) + '%';
      if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(SCREENS.length).padStart(2, '0');
      if (backBtn) backBtn.disabled = index === 0;

      let html = '<div class="hsid__q">';
      ids.forEach((id, n) => {
        const q = question(id);
        html += '<fieldset class="hhp__field' + (n ? ' hhp__field--second' : '') + '">' +
          '<legend class="hsid__q-title">' + esc(q.label) + '</legend>' +
          (q.help ? '<p class="hsid__q-help">' + esc(q.help) + '</p>' : '') +
          (q.multi ? '<p class="hhp__multi-hint">Select all that apply</p>' : '');
        html += q.type === 'shade' ? shadeMarkup()
          : '<div class="hsid__options hhp__options">' +
            q.options.map(o => {
              const picked = q.multi
                ? Array.isArray(answers[id]) && answers[id].indexOf(o.id) >= 0
                : answers[id] === o.id;
              return optionMarkup(q, o, picked);
            }).join('') + '</div>';
        html += '</fieldset>';
      });
      const btn = needsButton(ids);
      if (btn) {
        html += '<div class="hhp__actions"><button type="button" class="hsid__btn" data-continue>' +
          (index === SCREENS.length - 1 ? 'Build my plan' : 'Continue') + '</button></div>';
      }
      html += '</div>';
      mountQ.innerHTML = html;

      mountQ.querySelectorAll('.hhp__opt').forEach(b =>
        b.addEventListener('click', () => choose(b.dataset.q, b.dataset.value, btn)));
      mountQ.querySelectorAll('.hsid__fam').forEach(b =>
        b.addEventListener('click', () => { shadeFamilyOpen = b.dataset.family; renderScreen(); }));
      mountQ.querySelectorAll('.hsid__tone').forEach(b =>
        b.addEventListener('click', () => {
          answers.shadeTone = b.dataset.tone;
          answers.shade = HHP.SHADE_INDEX[b.dataset.tone].plan;
          renderScreen();
        }));
      const cont = mountQ.querySelector('[data-continue]');
      if (cont) cont.addEventListener('click', () => advance(ids));
    }

    /* « Aucun » vide le reste, et choisir autre chose le retire. */
    function choose(id, value, manual) {
      const q = question(id);
      if (!q.multi) {
        answers[id] = value;
        if (!manual) {
          mountQ.querySelectorAll('.hhp__opt[data-q="' + id + '"]').forEach(b =>
            b.setAttribute('aria-checked', String(b.dataset.value === value)));
          later(next, 190);
          return;
        }
        renderScreen();
        return;
      }
      const excl = q.exclusive || [];
      let list = Array.isArray(answers[id]) ? answers[id].slice() : [];
      if (list.indexOf(value) >= 0) list = list.filter(v => v !== value);
      else if (excl.indexOf(value) >= 0) list = [value];
      else list = list.filter(v => excl.indexOf(v) < 0).concat([value]);
      answers[id] = list;
      renderScreen();
    }

    const screenDone = ids => ids.every(id => {
      const v = answers[id];
      return question(id).multi ? Array.isArray(v) && v.length : typeof v === 'string' && v;
    });

    function advance(ids) {
      if (!screenDone(ids)) {
        mountQ.classList.remove('hhp__q--nudge');
        void mountQ.offsetWidth;
        mountQ.classList.add('hhp__q--nudge');
        return;
      }
      next();
    }

    function next() {
      if (index < SCREENS.length - 1) {
        index += 1;
        track('screen', { screen: index + 1, progress_pct: Math.round(((index + 1) / SCREENS.length) * 100) });
        renderScreen();
      } else {
        if (fill) fill.style.width = '100%';
        track('complete', { progress_pct: 100 });
        flushTrack(false);
        runLoading();
      }
    }

    function back() { if (index > 0) { index -= 1; renderScreen(); } }

    /* ---- Résultat ---- */

    function runLoading() {
      show('loading');
      const steps = screens.loading.querySelectorAll('.hsid__step');
      steps.forEach(s => s.classList.remove('is-on', 'is-done'));
      steps.forEach((s, i) => {
        later(() => s.classList.add('is-on'), 180 + i * 620);
        later(() => s.classList.add('is-done'), 620 + i * 620);
      });
      later(() => { renderResult(HHP.buildPlan(answers)); show('result'); },
            400 + steps.length * 620);
    }

    /* Portraits illustratifs. Rien ne relie un visage à un conseil ; la seule
       règle est que deux cartes affichées à la suite n'aient pas le même. */
    function faces() {
      if (!library) return [];
      return Array.prototype.slice.call(library.querySelectorAll('[data-expert-photo] img'));
    }
    let faceCursor = 0;
    function bubble(pool) {
      if (!pool.length) return '';
      const img = pool[faceCursor % pool.length];
      faceCursor += 1;
      return '<span class="hhp__by"><span class="hsid__expert-face">' + img.outerHTML +
        '</span><span>HerLoom Styling Expert</span></span>';
    }

    function card(id, pool) {
      const c = HHP.CARDS[id];
      return '<article class="hhp__card">' +
        '<h4>' + esc(c.title) + '</h4>' +
        '<p>' + esc(c.body) + '</p>' +
        (pool ? bubble(pool) : '') +
        (c.source ? '<p class="hhp__src"><a href="' + esc(c.source.url) +
          '" target="_blank" rel="noopener noreferrer">' + esc(c.source.title) + '</a></p>' : '') +
        '</article>';
    }

    function block(num, title, inner, extraClass) {
      return '<section class="hsid__block hhp__section' + (extraClass ? ' ' + extraClass : '') + '">' +
        '<div class="hsid__block-head"><span class="hsid__block-num">' + num + '</span>' +
        '<h3 class="hsid__block-title">' + esc(title) + '</h3></div>' + inner + '</section>';
    }

    function heatBlock(plan) {
      const rows = Array.isArray(CFG.heatChart) ? CFG.heatChart : [];
      const s = plan.heat.setting;
      const chart = rows.map(r => {
        const on = String(r.c).indexOf(String(s.c)) >= 0;
        return '<div class="hhp__chart-row' + (on ? ' is-match' : '') + '">' +
          '<span class="hhp__chart-temp"><b>' + esc(r.f) + '</b><i>' + esc(r.c) + '</i></span>' +
          '<span class="hhp__chart-label">' + esc(r.label) + '</span>' +
          (on ? '<span class="hhp__chart-tag">Yours</span>' : '') + '</div>';
      }).join('');
      return '<div class="hhp__numeric">' +
          '<p class="hhp__chart-title">Start here</p>' +
          '<p class="hhp__numeric-value">' + s.f + '°F <span>/ ' + s.c + '°C</span></p>' +
          '<p class="hhp__why">' + esc(plan.heat.why) + '</p>' +
        '</div>' +
        (chart ? '<div class="hhp__chart">' + chart + '</div>' : '') +
        (CFG.heatChartNote ? '<p class="hhp__chart-note">' + esc(CFG.heatChartNote) + '</p>' : '');
    }

    function cards(ids, pool) {
      return '<div class="hhp__cards">' + ids.map(id => card(id, pool)).join('') + '</div>';
    }

    /* Le fantome epouse la forme de la vraie carte : une barre de titre, puis
       une barre par ligne que le corps occupera. Seules des longueurs sortent
       d'ici, jamais un caractere du texte verrouille. */
    const CH_TITLE = 34;   /* caracteres par ligne au corps du titre */
    const CH_BODY = 46;    /* caracteres par ligne dans le paragraphe */

    function ghostCard(titleChars, bodyChars) {
      const tw = Math.max(42, Math.min(96, Math.round(titleChars / CH_TITLE * 100)));
      const rows = Math.max(3, Math.min(9, Math.round(bodyChars / CH_BODY)));
      let out = '<span class="hsid__ghost-line hhp__ghost-title" style="width:' + tw + '%"></span>';
      for (let i = 0; i < rows; i++) {
        /* la derniere ligne d'un paragraphe est toujours plus courte */
        const w = i === rows - 1 ? 44 + (i * 13) % 26 : 93 + (i * 5) % 7;
        out += '<span class="hsid__ghost-line" style="width:' + w + '%"></span>';
      }
      return '<span class="hhp__ghost-card" aria-hidden="true">' + out + '</span>';
    }

    const shapeOf = ids => ids.map(id => {
      const c = HHP.CARDS[id] || {};
      return [(c.title || '').length, (c.body || '').length];
    });

    function lockedBlock(num, title, ids) {
      const shapes = shapeOf(ids);
      return '<section class="hsid__block hsid__block--locked">' +
        '<div class="hsid__block-head"><span class="hsid__block-num">' + num + '</span>' +
        '<h3 class="hsid__block-title">' + esc(title) + '</h3>' +
        '<span class="hsid__locked-count">' + shapes.length + '</span></div>' +
        '<div class="hsid__locked-body">' +
        shapes.map(sh => ghostCard(sh[0], sh[1])).join('') +
        '</div></section>';
    }

    function unlockPanel(total) {
      return '<div class="hsid__unlock hhp__unlock">' +
        '<span class="hsid__unlock-icon" aria-hidden="true">' + ICONS.lock + '</span>' +
        '<h3 class="hsid__unlock-title">' + esc(CFG.lockTitle || 'That was the why. The how is inside.') + '</h3>' +
        '<p class="hsid__unlock-count">' + total + ' more steps written for your answers</p>' +
        (CFG.lockText ? '<p class="hsid__unlock-text">' + esc(CFG.lockText) + '</p>' : '') +
        (CFG.lockCtaUrl ? '<a class="hsid__btn hsid__unlock-btn" href="' + esc(CFG.lockCtaUrl) + '">' +
          esc(CFG.lockCtaLabel || 'Get my HerLoom brush') + '</a>' : '') +
        (CFG.lockNote ? '<p class="hsid__unlock-note">' + esc(CFG.lockNote) + '</p>' : '') +
        '</div>';
    }

    const GOAL_TITLE = { smooth: 'Smooth and sleek', volume: 'Volume at the root',
                         shape: 'A cleaner shape', fast: 'A faster morning' };

    function chips(a) {
      const label = (qid, v) => {
        const q = question(qid);
        const o = q.options && q.options.filter(x => x.id === v)[0];
        return o ? o.label : null;
      };
      const out = [label('length', a.length), label('shape', a.shape), label('strand', a.strand)];
      if (a.shadeTone && HHP.SHADE_INDEX[a.shadeTone]) out.push(HHP.SHADE_INDEX[a.shadeTone].label);
      out.push(label('obstacle', a.obstacle));
      return out.filter(Boolean);
    }

    function renderResult(plan) {
      const pool = faces();
      faceCursor = 0;
      const a = plan.answers;
      const s = plan.sections;
      let html = '';

      html += '<div class="hsid__card hhp__recap">' +
        '<p class="hsid__eyebrow">Your HerLoom hair plan</p>' +
        '<h2 class="hsid__card-title">' + esc(GOAL_TITLE[plan.goal] || '') + '</h2>' +
        '<div class="hsid__tags">' + chips(a).map(t =>
          '<span class="hsid__tag">' + esc(t) + '</span>').join('') + '</div>' +
        '<button type="button" class="hsid__skip" data-restart>Change my answers</button>' +
        '</div>';

      html += block('01', "What's actually going on with your hair", cards(s.insight, pool));
      html += block('02', 'Your starting setting', heatBlock(plan));
      html += block('03', 'Two things worth knowing', cards(s.facts, pool));

      const rest = [['04', 'Your method', s.method],
                    ['05', 'Making it last', s.care],
                    ['06', 'The mistakes that cost you', s.mistakes],
                    ['07', "If it's not working", s.trouble]];

      if (TEASER) {
        html += unlockPanel(plan.lockedCount);
        html += '<div class="hsid__locked hhp__locked">';
        rest.forEach(([n, title, ids]) => { html += lockedBlock(n, title, ids); });
        html += '</div>';
      } else {
        // pas de bulle ici : elle perd son sens si elle signe chaque carte
        rest.forEach(([n, title, ids]) => { html += block(n, title, cards(ids)); });
        if (plan.sources.length) {
          html += block('08', 'Where this comes from',
            '<ul class="hhp__sources">' + plan.sources.map(src =>
              '<li><a href="' + esc(src.url) + '" target="_blank" rel="noopener noreferrer">' +
              esc(src.title) + ' ' + ICONS.link + '</a></li>').join('') + '</ul>');
        }
      }

      mountR.innerHTML = html;

      const restart = mountR.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', () => {
        track('restart');
        answers = {}; index = 0; shadeFamilyOpen = null;
        renderScreen(); show('quiz');
      });
      const unlock = mountR.querySelector('.hsid__unlock-btn');
      if (unlock) unlock.addEventListener('click', () => { track('unlock_click'); flushTrack(true); });
    }

    /* ---- Câblage ---- */

    root.querySelectorAll('[data-start]').forEach(b =>
      b.addEventListener('click', () => {
        track('start');
        openDoors(() => { index = 0; renderScreen(); show('quiz'); });
      }));
    if (backBtn) backBtn.addEventListener('click', back);

    track('view');
    renderScreen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
